import { allDevicesColorSelectBox } from '../productDisplay/_shopperActions';
import { quickConvert } from '../international/_intl';
import Cookies from 'js-cookie';

export const flatSizeMobileQVPrice = (productPrice) => {
	if ($('.mobilePage').length > 0) {
		//For mobile quick view flat sizes
		let yourPrice = '';
		let currency = $('.price-number').text();
		let currencyFinal = currency.substring(0, currency.search(/\d/));
		productPrice = parseFloat(productPrice).toFixed(2)
		yourPrice = productPrice;
		const zonosIsWorking = typeof zonos === 'object' ? true : false;
		let priceVal = zonosIsWorking ? yourPrice : quickConvert(yourPrice);
		let sizePriceContainer = $(`<span class='thisPrice price'>${Cookies.get('zCountry') === 'US' ? '$' : ''}${priceVal}</span>`);

		$('.thisPrice').remove();
		if ($('.dynamicModalContainer .original-price').length > 0) {
			$(sizePriceContainer).insertBefore($('.quick-view-main-price .price-wrapper'));
			var origPrice = $('.dynamicModalContainer  .original-price .price-number').text();
			//If Zonos is blocked, origPrice needs to come from another spot
			if(origPrice === '') {
				origPrice = $('.original-price').text();
				origPrice = origPrice.replace('Orig.', '');
			}
			var origPriceIndex = origPrice.lastIndexOf(currencyFinal);
			var origPriceFinal = origPrice.substring(origPriceIndex + 1);
			var yourPriceUSD = parseFloat(yourPrice).toFixed(2);
			var originalPriceUSD = parseFloat($('.original-price').children().last().attr('data-usd')).toFixed(2);
			
			if (Cookies.get('zCountry') !== 'US' && yourPriceUSD !== originalPriceUSD) {
				$('.dynamicModalContainer .thisPrice').remove();
				$('.thisSalePrice').remove();
				$('.quick-view-main-price .price-wrapper').show();
				$('.quick-view-main-price .now-price').addClass('orgNowPrice');
				$('.orgNowPrice').hide();
				$('.quick-view-main-price .price-wrapper').append(
					$(`<span class="thisSalePrice price now-price">Now ${Cookies.get('zCountry') === 'US' ? '$' : ''}${yourPriceUSD}</span>`)
				);
				try {
					if (typeof zonos === 'object') {
						zonos.displayCurrency();
					}
				} catch (e) {
					console.log(e);
				}
			} else {
				if (Cookies.get('zCountry') !== 'US') {
					$(sizePriceContainer).insertBefore($('.quick-view-main-price .price-wrapper'));
					$('.dynamicModalContainer .price-wrapper').hide();
				}
				try {
					if (typeof zonos === 'object') {
						zonos.displayCurrency();
					}
				} catch (e) {
					console.log(e);
				}
			}
			if (Cookies.get('zCountry') === 'US' && origPriceFinal !== parseFloat(yourPrice).toFixed(2)) {
				$('.dynamicModalContainer .thisPrice').remove();
				$('.thisSalePrice').remove();
				$('.quick-view-main-price .price-wrapper').show();
				$('.quick-view-main-price .now-price').addClass('orgNowPrice');
				$('.orgNowPrice').hide();

				$('.quick-view-main-price .price-wrapper').append(
					$(`<span class="thisSalePrice price now-price">Now ${Cookies.get('zCountry') === 'US' ? '$' : ''}${priceVal}</span>`)
				);
			} else {
				if (Cookies.get('zCountry') === 'US') {
					$(sizePriceContainer).insertBefore($('.quick-view-main-price .price-wrapper'));
					$('.dynamicModalContainer .price-wrapper').hide();
				}
			}

			if (yourPrice == '') {
				$('.thisPrice').remove();
				$('#mainPrice .price-wrapper').show();
				$('.orgNowPrice').show();
				$('.thisSalePrice').hide();
			}
			if ($('.dynamicModalContainer .size-selected').length === 0) {
				$('.dynamicModalContainer .price-wrapper').show();
				$('.dynamicModalContainer .thisPrice').remove();
			}
		}

		if ($('.dynamicModalContainer .original-price').length == 0 &&
			$('.dynamicModalContainer .now-price').length == 0 &&
			$('.dynamicModalContainer .quick-view-main-price').text().indexOf('-') !== -1
		) 
			{
			//price range with no sale price
			if ($('.dynamicModalContainer .size-selected').hasClass('DisabledFlatSize')) {
				$('.dynamicModalContainer .thisPrice').remove();
				$('.dynamicModalContainer .quick-view-main-price').show();
			}
			if (!$('.dynamicModalContainer .size-selected').hasClass('DisabledFlatSize') && $('.dynamicModalContainer .size-selected').text().indexOf('-') == -1) 
			{
				$(sizePriceContainer).insertBefore($('.quick-view-main-price'));
				$('.dynamicModalContainer .quick-view-main-price').hide();
			}
			if (
				$('.dynamicModalContainer .size-selected').length === 0 ||
				($('.dynamicModalContainer .size-selected').length > 0 && $('.dynamicModalContainer .color-select').val() == '')
			) {
				$('.dynamicModalContainer .quick-view-main-price').show();
				$('.dynamicModalContainer .thisPrice').remove();
			}
		}
	} else if ($('.mobilePage').length > 0 && $('.dynamicModalContainer').length > 0 && selectedAttrName === 'Color') {
		$('.dynamicModalContainer .price-wrapper').show();
		$('.dynamicModalContainer .thisPrice').remove();
	}

};